module.exports = __webpack_public_path__ + "static/img/Bachelor_010609.34e9546.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010609.gif
// module id = 199
// module chunks = 0